import { action } from 'easy-peasy';

import { IActionSetDashboardAvailableTeamIds } from '../types';

const setDashboardAvailableTeamIds: IActionSetDashboardAvailableTeamIds = action(
  (state, payload) => {
    state.dashboardAvailableTeamIds = payload;
  },
);

export default setDashboardAvailableTeamIds;
